<template>
  <div>
    <div v-if="this.currentTab === 'fundInfo'">
      <fundinfo :route_id="route_id" :is_active="is_active" :passed="passed" />
    </div>

    <div v-else-if="this.currentTab === 'fundMemberInfo'">
      <fundcompany :company_id="company_id" />
    </div>

    <div v-else>
      <v-container v-if="fundCompany[0]">
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="title">机构名称：{{ fundCompany[0].company_title }}</div>
              <div class="title">管理规模：{{ fundCompany[0].scale }}</div>
              <div class="title">办公地址：{{ fundCompany[0].address }}</div>
              <div class="title">公司性质：{{ fundCompany[0].type }}</div>
              <div class="title">成立日：{{ fundCompany[0].estabilsh_date }}</div>
            </div>
          </v-card-title>
        </v-card>
      </v-container>
      <v-data-table :headers="headers" :items="fundCompany" class="elevation-1">
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.code }}</td>
          <td class="text-xs-center">
            <!-- <router-link :to="`/fund/${props.item.id}`"> -->
            <!-- <div @click="changeTab('fundInfo')"> -->
            {{ props.item.title }}
            <!-- </div> -->
            <!-- </router-link> -->
          </td>
          <td class="text-xs-center">{{ props.item.type }}</td>
          <td class="text-xs-center">{{ props.item.scale }}</td>
          <td class="text-xs-center" style="1000px">
            <v-rating v-model="props.item.rating" background-color="orange lighten-3" color="orange" small readonly></v-rating>
          </td>
          <td class="text-xs-center">{{ props.item.value }}</td>
          <td class="text-xs-center">{{ props.item.recent_value }}</td>
          <td class="text-xs-center">{{ props.item.unit_value }}</td>
          <td class="text-xs-center">{{ props.item.recent_unit_value }}</td>
          <td class="text-xs-center">{{ props.item.cumulative_value }}</td>
          <td class="text-xs-center">{{ props.item.recent_cumulative_value }}</td>
          <td class="text-xs-center">{{ props.item.estabilsh_date }}</td>
          <td class="text-xs-center">
            <!-- <router-link :to="`/fundCompany/${props.item.manager_id}`"> -->
            <!-- <div @click="changeTab('fundMemberInfo')"> -->
            {{ props.item.name }}
            <!-- </div> -->
            <!-- </router-link> -->
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import fundinfo from '@/components/FundInfo.vue'
import fundcompany from '@/components/FundCompany.vue'
import Account from '@/components/Account.vue'

export default {
  components: {
    fundinfo,
    fundcompany,
    Account
  },
  props: {
    company_id: {
      type: String,
      default: ''
    },
    route_id: {
      type: Number,
      default: ''
    },
    is_active: {
      type: String,
      default: false
    },
    passed: {
      type: String,
      default: 'no_pass'
    }
  },
  data() {
    return {
      // table
      headers: [
        { text: '基金代码', align: 'center', value: 'code' },
        { text: '基金名称', align: 'center', value: 'title' },
        { text: '基金类型', align: 'center', value: 'type' },
        { text: '基金规模', align: 'center', value: 'scale' },
        { text: '基金评级', align: 'center', value: 'rating' },
        { text: '净值估算', align: 'center', value: 'value' },
        { text: '最近净值', align: 'center', value: 'recent_value' },
        { text: '单位净值', align: 'center', value: 'unit_value' },
        { text: '单位最近净值', align: 'center', value: 'recent_unit_value' },
        { text: '累计净值', align: 'center', value: 'cumulative_value' },
        {
          text: '累计最近净值',
          align: 'center',
          value: 'recent_cumulative_value'
        },
        { text: '成立日', align: 'center', value: 'estabilsh_date' },
        { text: '基金经理', align: 'center', value: 'name' }
      ],
      device: 'desktop',
      currentTab: ''
    }
  },
  watch: {
    company_id: {
      handler(newValue, oldValue) {
        this.fetchData()
      },
      deep: true
    }
  },
  computed: mapGetters({
    fundCompany: 'fundCompany'
  }),
  created() {
    this.fetchData()

    if (
      navigator.userAgent.indexOf('iPhone') > -1 ||
      navigator.userAgent.indexOf('Android') > -1
    ) {
      this.device = 'mobile'
    } else {
      this.device = 'desktop'
    }
  },
  methods: {
    fetchData() {
      this.$store.dispatch('GetFundCompany', this.company_id)
    },
    changeTab(link) {
      this.currentTab = link
    }
  }
}
</script>
